import {
  QuestionEntityEditorProps,
  SurveyQuestionsField,
} from '@/modules/user-survey/views/UserSurveyEditor/components/BlocksList/types';
import { QuestionTypeEnum } from '@/types/schema';

import SelectEditorOptionsList from '../../components/SelectEditorOptionsList';

const SingleSelectField: SurveyQuestionsField = {
  type: QuestionTypeEnum.SingleSelect,
  Editor: (props: QuestionEntityEditorProps) => <SelectEditorOptionsList {...props} />,
};

export default SingleSelectField;
